import { render } from "./JumlahKutipanSehingaHariIni.vue?vue&type=template&id=ab0899e4"
import script from "./JumlahKutipanSehingaHariIni.vue?vue&type=script&lang=js"
export * from "./JumlahKutipanSehingaHariIni.vue?vue&type=script&lang=js"

import "./JumlahKutipanSehingaHariIni.vue?vue&type=style&index=0&id=ab0899e4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__